import type { NavigationLinkProps } from "@/widgets/navigation/models/interface";

export const NAVIGATION_LINKS_IN_PRINCIPAL: NavigationLinkProps[] = [
    // {
    //     index: 0,
    //     path: "/dashboard",
    //     text: "대시보드",
    // },
    {
        index: 1,
        path: "/student-setting",
        text: "학생 관리",
    },
    {
        index: 2,
        path: "/class-management",
        text: "반 관리",
    },
    {
        index: 3,
        path: "/challenge-up",
        text: "챌린지업",
    },
    {
        index: 4,
        path: "/concept-enhancement",
        text: "튼튼개념쌓기",
    },
    {
        index: 5,
        path: "/ai-tutor",
        text: "AI 매티",
    },
];
